import React from 'react';
import { useTranslation } from "react-i18next";
import OfflineSyncManager from '@/components/OfflineSyncManager';

const OfflineSyncPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <OfflineSyncManager />
      </div>
    </div>
  );
};

export default OfflineSyncPage;
